module.exports = __webpack_public_path__ + "12d6014bb7e4973888adeb52b5d41df3.png";